import script from "./HrPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPage.vue?vue&type=script&setup=true&lang=js"

import "./HrPage.vue?vue&type=style&index=0&id=471df9e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471df9e4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
